import React from 'react'
import { t } from '../../../i18n'

interface ReadOnlyNoticeProps {
  message?: string
  variant?: 'info' | 'warning'
}

const ReadOnlyNotice = ({ message, variant = 'info' }: ReadOnlyNoticeProps) => (
  <div className={`alert alert-${variant}`} role="alert">
    {message ?? t('versioning.read_only_notice')}
  </div>
)

export default ReadOnlyNotice
